export default __webpack_public_path__ + "static/media/1859.08231aa0.png";